module.exports = __webpack_public_path__ + "static/media/brand_analytics.84250841.png";